/**
 * Firebase web-app configuration for Syntry — ONE web app, used by every build.
 *
 * It is a WEB app registered in the `businext-app` Firebase project (the same
 * project `firebase.json` / `.firebaserc` deploy the PWA to):
 *
 *   Syntry → 1:71633264934:web:81047fcb3743fbdbe6e1e7  (GA stream G-5Q250E4QPJ)
 *
 * `npm run dev`, the PWA on syntry.web.app and the native shells (`cap sync`
 * packages the same production `dist/`, and the WebView runs this web config)
 * all report to it. Development traffic is told apart by `debug_mode`, which
 * only a dev build sends (`src/services/analytics.ts`): it shows in GA4 →
 * DebugView, and the property's developer-traffic data filter keeps it out of
 * the reports. The two web apps used before (`syntry-dev`, `syntry-rel`) are
 * history — docs/analytics.md.
 *
 * `FIREBASE_WEB_APPS` keeps its `dev` / `release` keys although both are now the
 * same app: Syntry Desktop mirrors this file (`npm run sync:mobile`) and its
 * override contract iterates the map and re-exports every name exported here.
 * Do not drop the map or add an export without changing that repo too.
 *
 * ⚠ These values are NOT secrets. A Firebase web config (including `apiKey`)
 * is designed to ship in the browser bundle — it identifies the project, it
 * does not grant access to it; project security lives in Firebase rules and
 * the Google Cloud API-key restrictions, not in hiding this file. API keys are
 * project-level: this one is also Syntry Desktop's, so its restrictions must
 * keep both apps working. The parent ERPat app ships its own web config the
 * same public way, from its server env (`application/helpers/
 * erpat_web_analytics_helper.php`). Re-fetch with
 * `firebase apps:sdkconfig web 1:71633264934:web:81047fcb3743fbdbe6e1e7 --project businext-app`
 * and keep the object identical to it — `appId` and `measurementId` are a
 * pair: online, the SDK uses the measurement id the server maps to the app id.
 *
 * Only Analytics is initialised from this config (see
 * `src/services/analytics.ts`). No Firestore/Auth/Storage/Realtime Database —
 * Syntry's data lives in ERPat, and the Firebase Hosting deploy needs no client
 * SDK at all. `databaseURL` is here only because it is part of the registered
 * config; nothing imports `firebase/database`.
 */
import type { FirebaseOptions } from 'firebase/app';

/** The Syntry web app, exactly as the Firebase console gives it. */
const SYNTRY_WEB_APP: Readonly<FirebaseOptions> = Object.freeze({
  apiKey: 'AIzaSyDWreI34XoOT0fqGye3C9IzljpuUFh3dLs',
  authDomain: 'businext-app.firebaseapp.com',
  databaseURL: 'https://businext-app-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'businext-app',
  storageBucket: 'businext-app.firebasestorage.app',
  messagingSenderId: '71633264934',
  appId: '1:71633264934:web:81047fcb3743fbdbe6e1e7',
  measurementId: 'G-5Q250E4QPJ',
});

/** Both build channels — kept as a map for Syntry Desktop's override contract. */
export const FIREBASE_WEB_APPS: Readonly<Record<'dev' | 'release', FirebaseOptions>> = Object.freeze({
  dev: SYNTRY_WEB_APP,
  release: SYNTRY_WEB_APP,
});

/** The config every build initialises Firebase with. */
export const FIREBASE_WEB_CONFIG: FirebaseOptions = SYNTRY_WEB_APP;
